import React, { useEffect, useState } from 'react';
import { event } from '../data/masterclass';
type Remaining = {
  days: number;
  hours: number;
  minutes: number;
};
function getRemaining(target: number): Remaining {
  const diff = Math.max(0, target - Date.now());
  return {
    days: Math.floor(diff / 86400000),
    hours: Math.floor(diff / 3600000 % 24),
    minutes: Math.floor(diff / 60000 % 60)
  };
}
export function Countdown() {
  const target = new Date(event.isoDate).getTime();
  const [remaining, setRemaining] = useState<Remaining>(() => getRemaining(target));
  useEffect(() => {
    const id = window.setInterval(() => setRemaining(getRemaining(target)), 30000);
    return () => window.clearInterval(id);
  }, [target]);
  const units: Array<[number, string]> = [[remaining.days, 'Days'], [remaining.hours, 'Hrs'], [remaining.minutes, 'Min']];
  return <div className="flex items-center gap-4 sm:gap-6" role="timer" aria-label="Time until the masterclass begins" data-id="element-20" data-mp="15by75syqmlon">
      {units.map(([value, label], i) => <React.Fragment key={label} data-id="element-21" data-mp="t23djiym9nfk" data-mpi={i}>
          {i > 0 && <span className="font-display text-3xl text-gold/30" aria-hidden="true" data-id="element-22" data-mp="t1k6ixai8jgb">
              :
            </span>}
          <div className="text-center" data-id="element-23" data-mp="17sswj7ibk6tz">
            <div className="font-display text-4xl font-bold leading-none text-gold tabular-nums sm:text-5xl" data-id="element-24" data-mp="12sy2iv38z14p">
              {String(value).padStart(2, '0')}
            </div>
            <div className="mt-1.5 text-[10px] font-semibold uppercase tracking-overline text-white/45" data-id="element-25" data-mp="a3hdm7eu62d8">
              {label}
            </div>
          </div>
        </React.Fragment>)}
    </div>;
}